export default __webpack_public_path__ + "static/media/bg-2.6d5cb6b5.jpg";